import { createContext } from 'react';

import { TAiPageChatMessageDto } from '@app-velocity/av-api-v2';

export type LoopContextType = null | {
  cycleLength: number;
  unaffectedMessagesCount: number;
  messages: TAiPageChatMessageDto[];
};

export const LoopContext = createContext<LoopContextType>(null);
